import { Controller } from "@hotwired/stimulus"
import { searchPlants } from "../lib/plant_search"
import { showAlert } from "../lib/alerts"

export default class extends Controller {
  static values = { addUrl: String }
  static targets = ["input", "results"]

  search() {
    const q = this.inputTarget.value
    if (q === "") {
      this.resultsTarget.innerHTML = ""
      return
    }

    searchPlants({ q, limit: 6 }).then((result) => {
      this.renderHits(result.hits)
    })
  }

  renderHits(hits) {
    if (hits.length === 0) {
      this.resultsTarget.innerHTML = `<div class="dropdown"><div class="input-search-result"><small>No plants found.</small></div></div>`
      return
    }
    this.resultsTarget.innerHTML = `<div class="dropdown">${hits.map(hit => this.renderHit(hit)).join("")}</div>`
  }

  renderHit(plant) {
    const name = plant.type === "Variety" ? plant.parent_name + ' "' + plant.name + '"' : plant.name
    return `<a class="input-search-result -sm" href="#" data-action="click->list-add-plant#add" data-plant-id="${plant.id}">
      <img class="data-img-xs" src="${plant.thumb || '/permapeople-permaculture-plant-database-blank.jpg'}" />
      <label class="input-search-result-name" style="margin-left:0.5rem">${this.escapeHtml(name)} <span>${this.escapeHtml(plant.scientific_name)}</span></label>
    </a>`
  }

  add(event) {
    event.preventDefault()
    const plantId = event.currentTarget.dataset.plantId
    const token = document.querySelector('meta[name="csrf-token"]')?.content

    fetch(this.addUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": token,
      },
      body: JSON.stringify({ list: { plant_id: plantId } }),
    }).then((response) => {
      if (response.ok) {
        showAlert("Plant added to list")
        this.inputTarget.value = ""
        this.resultsTarget.innerHTML = ""
        Turbo.visit(window.location.href, { action: "replace" })
      } else {
        showAlert("Could not add plant")
      }
    })
  }

  escapeHtml(str) {
    if (!str) return ""
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
